module.exports = __webpack_public_path__ + "img/kaof.88f96f56.jpg";